import React from 'react';

import { Divider } from '@mui/material';

import { InbodyType } from '../../../../../../../shared/constants/inbody-info/InbodyType';
import { Flags } from '../../../../../../../utils-types';
import { CustomerInfo } from '../../NgzInbodyIndicatorsTab.settings';
import { CustomerParam } from './CustomerParam/CustomerParam';
import { getFeetInchesFromInches } from '../../../../../../../shared/utils/mathUtils/getFeetInchesFromInches/getFeetInchesFromInches';

type CustomerInfoSectionProps = {
  customerInfo: CustomerInfo;
  inbodyTypeFlags: Flags<InbodyType>;
};

const CustomerInfoSection = ({
  customerInfo,
  inbodyTypeFlags,
}: CustomerInfoSectionProps) => {
  const { value: heightValue } = getFeetInchesFromInches(customerInfo.height);

  return (
    <>
      {!inbodyTypeFlags.NON_INBODY && (
        <>
          <CustomerParam
            title="ID"
            value={customerInfo.inbodyId}
            className="private-info"
          />
          <Divider orientation="vertical" flexItem />
        </>
      )}
      <CustomerParam title="Height" value={heightValue} />
      <Divider orientation="vertical" flexItem />
      <CustomerParam title="Age" value={customerInfo.age} />
      <Divider orientation="vertical" flexItem />
      <CustomerParam title="Gender" value={customerInfo.gender} />
    </>
  );
};

export { CustomerInfoSection };
